import PrimaryButton from "../../../Components/Buttons/primary-button";

import { modalVariants } from "../../../Utils/constants";

import { AstraIcon } from "../../../Assets/Images";

export default function renderAstraSignUp(modalContext, onOpenAstraPortal) {
  const { updateModalComponent, setModalVariant, onModalClose } = modalContext;

  const handleOpenAstraPortal = () => {
    onOpenAstraPortal();
    onModalClose();
  };

  updateModalComponent(() => {
    return (
      <>
        <div className="modal-dialog-content">
          <AstraIcon className="d-block astra-icon mb-4 mx-auto" />
          <h3 className="modal-status-title mb-2">Add funds instantly with your debit card</h3>
          <span className="modal-content-text mb-0">
            Funds arrive in seconds. Secure transfers powered by Astra.
          </span>
        </div>
        <div className="action-container split-equally">
          <PrimaryButton onClick={handleOpenAstraPortal}>Link card</PrimaryButton>
          <PrimaryButton className="secondary-colors" onClick={onModalClose}>
            Cancel
          </PrimaryButton>
        </div>
      </>
    );
  });
  setModalVariant(modalVariants.promptDialog);
}
